/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputPushToken
 */
export interface InputPushToken {
    /**
     * 
     * @type {string}
     * @memberof InputPushToken
     */
    token?: string;
}

/**
 * Check if a given object implements the InputPushToken interface.
 */
export function instanceOfInputPushToken(value: object): boolean {
    return true;
}

export function InputPushTokenFromJSON(json: any): InputPushToken {
    return InputPushTokenFromJSONTyped(json, false);
}

export function InputPushTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputPushToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function InputPushTokenToJSON(value?: InputPushToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

